angular.module('swapick')
.controller('AccountEditCtrl', AccountEditCtrl);

function AccountEditCtrl ($auth, $rootScope, authService, notifyManager,
    $ionicSideMenuDelegate, DataService, clientId, clientSecret,Districts,
    $http, Entities, $ionicLoading, initialLoaderManager, appVersion) {

    this.appVersion = appVersion;

    this.loader = initialLoaderManager.makeLoader(()=>(
        Entities.waitForUser()
        .then(u => {
            this.user = u;
            return Districts
            .getDistricts()
            .then(districts => {
              this.districts = districts;
              return districts;
            })
            .then(districts => {
                if(!this.user.district){
                  return this.user;
                }
                return Districts.getDistrictByName(this.user.district)
                .then(district => {
                  if(district){
                      this.user.districtMapped = district
                  }
                  return this.user;
                })
            })
        })

    ));

    this.saveUser = () => {
      $ionicLoading.show();
      let formData = {
          firstname: this.user.firstname,
          lastname: this.user.lastname,
          address: this.user.address,
          zip: this.user.zip,
          city: this.user.city,
          district: this.user.districtMapped.nome,
          districtId: this.user.districtMapped.id,
          telephone: this.user.telephone,
          //facebookAccessToken: "u1h2u3h127u41u2h41y8b413",
          //"facebookId": "32143241231231234455"

      }
      let payload = { fos_user_profile_form : formData};
      return DataService.me.patch(payload)
      .then(()=>{
        return notifyManager.success("Dati salvati");
      })
      .finally(()=>{
        $ionicLoading.hide()
      })

    }


    this.loader.load();


}



// WEBPACK FOOTER //
// ./src/controllers/account-edit-controller.js